import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import LinkIcon from "../../../../../../assets/icons/LinkIcon.svg";
import moment from "moment";
import { listAttachmentsProps } from "./customer-view-details-view-attachment-info.props";
import { getIconBasedOnFileExt } from "../../../../../../utils/fetchIconForExtension";
import AttachmentActions from "./attachment-actions";
import { convertUTCToLocal } from "../../../../../../utils/utils";

const formatFileSize = (size: number | null) => {
  if (!size) return "-";
  const kb = size / 1024;
  return `${kb.toFixed(1)} KB`;
};

const getFileIcon = (fileName: string) => {
  const ext = fileName?.split(".").pop()?.toLowerCase();
  return getIconBasedOnFileExt(ext || "");
};

const ListAttachments: React.FC<listAttachmentsProps> = ({
  leadId,
  attachmentsList,
  fetchAttachments,
  setLoading,
  setAlertMessage,
  setAlertOpen,
  setAlertType,
  disableEdit,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuIndex, setMenuIndex] = useState<number | null>(null);
  const handleMenuOpen = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    setAnchorEl(e.currentTarget);
    setMenuIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuIndex(null);
  };

  const getFullName = (obj: any) => {
    const first = obj?.first_name || "";
    const last = obj?.last_name || "";
    return `${first} ${last}`.trim();
  };

  return (
    <>
      <TableContainer>
        <Table className="attachments-table-wrapper">
          <TableHead>
            <TableRow>
              <TableCell>File Name</TableCell>
              <TableCell>Attached By</TableCell>
              <TableCell>Date Added</TableCell>
              <TableCell>Size</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attachmentsList?.map((item: any, index: number) => {
              const file = item?.file;
              const fileName =
                item.type === "LINK"
                  ? file.original_file_name || "Link"
                  : file.original_file_name;
              const fileLink = item.link;

              return (
                <TableRow key={item.id}>
                  <TableCell className="file-name-cell">
                    <div className="file-name-wrapper">
                      <div className="name-icon-wrapper">
                        {item.type === "LINK" ? (
                          <img src={LinkIcon} />
                        ) : (
                          getFileIcon(file.original_file_name)
                        )}

                        {fileName}
                      </div>
                      <div className="ellipse-icon-wrapper">
                        <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                          <MoreHorizIcon fontSize="small" />
                        </IconButton>
                        <AttachmentActions
                          open={menuIndex === index}
                          anchorEl={anchorEl}
                          onClose={() => {
                            handleMenuClose();
                          }}
                          type={item.type}
                          item={item}
                          fetchAttachments={fetchAttachments}
                          setLoading={setLoading}
                          setAlertMessage={setAlertMessage}
                          setAlertOpen={setAlertOpen}
                          setAlertType={setAlertType}
                          disableEdit={disableEdit}
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>{getFullName(item?.updatedBy)}</TableCell>
                  <TableCell>
                    {item.created_at
                      ? convertUTCToLocal(item?.created_at, "MM/DD/YY")
                      : "-"}
                  </TableCell>
                  <TableCell>{formatFileSize(file?.size)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ListAttachments;
